import Layout from './../Layout';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import jsPDF from 'jspdf';

const API_BASE_URL = 'https://stage.beachcabana.lk/hotelmanage/api.php';
const AUTH_HEADER = {
  headers: {
    'Authorization': 'Basic YWRtaW46cGFzc3dvcmQ=',
    'Content-Type': 'application/json'
  }
};

export default function OrderProcessing() {
  const location = useLocation();
  const [orderDetails, setOrderDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    if (location.state && location.state.orderId && location.state.registration_id && location.state.token) {
      const id = location.state.orderId;
      const registration_id = location.state.registration_id;
      const token = location.state.token;
      fetchOrderDetails(id, registration_id, token);
    } else {
      setFetchError("Missing order ID, registration ID, or token.");
      setIsLoading(false);
    }
  }, [location.state]);

  const fetchOrderDetails = async (id, registration_id, token) => {
    setIsLoading(true);
    setFetchError(null);
    try {
      const response = await axios.post(
        `${API_BASE_URL}?param=getorderdetails`,
        { 
          order_id: id,
          reservation_id: registration_id,
          token: token
        },
        AUTH_HEADER
      );

      if (response.data.code === 200 && response.data.data) {
        const orderData = response.data.data;
        setOrderDetails({
          orderId: id,
          createdAt: orderData.user.checkin_date,
          items: orderData.items,
          subtotal: parseFloat(orderData.batch.sub_total),
          ordernote: orderData.batch.order_note,
          name: orderData.user.full_name
        });
      } else {
        setFetchError(response.data.message || "Failed to load order details.");
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
      setFetchError("Error fetching order details. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const generatePdf = () => {
    if (!orderDetails) {
      setFetchError("Order details not available for PDF generation.");
      return;
    }

    const doc = new jsPDF();
    let yPos = 10;
    const pageHeight = doc.internal.pageSize.height;

    doc.setFontSize(10);
    doc.text("Wood Chalets Ella", 10, yPos);
    yPos += 5;
    doc.text("Badulla Road, Bandarawela", 10, yPos);
    yPos += 5;
    doc.text("Phone: +94 77 141 6733 | Email: info@woodchaletsella.com.lk", 10, yPos);
    yPos += 15;

    doc.setFontSize(18);
    doc.text("Order Details", 10, yPos);
    yPos += 10;

    doc.setFontSize(12);
    doc.text(`Order ID: ${orderDetails.orderId}`, 10, yPos);
    yPos += 7;
    doc.text(`Order Date: ${new Date(orderDetails.createdAt).toLocaleString()}`, 10, yPos);
    yPos += 7;
    if (orderDetails.name) {
      doc.text(`Guest Name: ${orderDetails.name}`, 10, yPos);
      yPos += 7;
    }
    yPos += 3;

    doc.setFontSize(14);
    doc.text("Items:", 10, yPos);
    yPos += 7;

    doc.setFontSize(10);
    doc.text("Item Name", 10, yPos);
    doc.text("Qty", 80, yPos);
    doc.text("Unit Price", 110, yPos);
    doc.text("Total", 150, yPos);
    yPos += 5;
    doc.line(10, yPos, 200, yPos);
    yPos += 5;

    orderDetails.items.forEach(item => {
      doc.text(item.item_name, 10, yPos);
      doc.text(item.order_qty.toString(), 80, yPos);
      doc.text(`LKR ${parseFloat(item.unit_price).toLocaleString()}.00`, 110, yPos);
      doc.text(`LKR ${parseFloat(item.items_price).toLocaleString()}.00`, 150, yPos);
      yPos += 7;
    });

    yPos += 5;
    doc.line(10, yPos, 200, yPos);
    yPos += 5;

    doc.setFontSize(12);
    doc.text(`Subtotal: LKR ${orderDetails.subtotal.toLocaleString()}.00`, 150, yPos);
    yPos += 7;

    if (orderDetails.ordernote) {
      doc.text(`Note: ${orderDetails.ordernote}`, 10, yPos);
      yPos += 7;
    }

    const footerText = "Thank you for your order!";
    const footerYPos = pageHeight - 10;
    doc.setFontSize(10);
    doc.text(footerText, doc.internal.pageSize.width / 2, footerYPos, { align: 'center' });

    doc.save(`order_${orderDetails.orderId}.pdf`);
  };

  return (
    <Layout pageTitle="Order Process">
      <div className="mx-auto py-6 font-sans text-black bg-white min-h-screen flex flex-col justify-center items-center p-4">
        <h2 className="text-2xl font-bold mb-4 text-center">Order Submitted!</h2>
        <p className="text-lg text-gray-700 text-center mb-6">
          Thank you for your order. Your order is being processed.
        </p>

        {isLoading && <p className="text-gray-600">Loading order details...</p>}
        {fetchError && <p className="text-red-500">{fetchError}</p>}


        {orderDetails && (
          <button
            onClick={generatePdf}
            className="px-6 py-2 w-full bg-gray-600 text-white font-semibold rounded-lg hover:bg-gray-400"
          >
            Download Order Details PDF
          </button>
        )}

        <button
          onClick={() => window.location.href = '/'}
          className="px-6 py-2 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 mt-4"
        >
          Back to Home
        </button>
      </div>
    </Layout>
  );
}